import type { SubscriptionPlan, SubscriptionTier } from './entitlements';

export interface PlanFeature {
  text: string;
  included: boolean;
}

export interface SubscriptionPlanConfig {
  id: SubscriptionPlan;
  name: string;
  tier: SubscriptionTier;
  priceInCents: number;
  billingPeriod: 'monthly';
  description: string;
  features: PlanFeature[];
  popular?: boolean;
}

// Plan configurations matching the Edge Function pricing
export const SUBSCRIPTION_PLANS: SubscriptionPlanConfig[] = [
  {
    id: 'premium',
    name: 'Premium',
    tier: 'premium',
    priceInCents: 499,
    billingPeriod: 'monthly',
    description: 'Spicy images + videos with monthly credits',
    popular: true,
    features: [
      { text: 'Spicy images', included: true },
      { text: 'Videos', included: true },
      { text: '200 credits / month', included: true },
    ],
  },
  {
    id: 'vip',
    name: 'VIP',
    tier: 'vip',
    priceInCents: 999,
    billingPeriod: 'monthly',
    description: 'Highest tier with more monthly credits',
    features: [
      { text: 'Spicy images', included: true },
      { text: 'Videos', included: true },
      { text: '500 credits / month', included: true },
    ],
  },
];

export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function getPlanById(id: SubscriptionPlan): SubscriptionPlanConfig | undefined {
  return SUBSCRIPTION_PLANS.find((plan) => plan.id === id);
}
